import React, { useEffect } from 'react';
import { Button, Form, Input, message } from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useAuthContext from '../../contexts/AuthContext';

const { TextArea } = Input;

export const HelpModal = ({ setContact, handleCloseModalHelp }) => {
  const [form] = Form.useForm();
  const { dispatchAPI, user } = useAuthContext();
  const { t } = useTranslation();

  const sendMailHelp = async (body) => {
    try {
      await dispatchAPI('POST', {
        url: 'reclamations/sendHelp',
        body
      });
      message.success(t(`basiclayout.footer.modal_bug_success`));
      setContact(false);
      handleCloseModalHelp();
    } catch (e) {
      if (e.response) message.error(e.response.status);
    }
  };

  const handleSubmit = (values) => {
    sendMailHelp(values);
    handleCloseModalHelp();
    form.resetFields();
  };

  useEffect(() => {
    if (user)
      form.setFieldsValue({ ...user.insurer, object: 'Support informatique' });
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Form
        name="helpForm"
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 8 }}
        autoComplete="off"
        onFinish={handleSubmit}
      >
        <Form.Item label={t('basiclayout.footer.name_office')} name="name">
          <Input />
        </Form.Item>
        <Form.Item
          label={t('basiclayout.footer.first_name')}
          name="owner_first_name"
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t('basiclayout.footer.last_name')}
          name="owner_last_name"
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t('basiclayout.footer.phone_number')}
          name="phone_number"
        >
          <Input />
        </Form.Item>
        <Form.Item label={t('basiclayout.footer.email')} name="owner_email">
          <Input />
        </Form.Item>
        <Form.Item label={t('basiclayout.footer.object')} name="object">
          <Input />
        </Form.Item>
        <Form.Item label={t('basiclayout.footer.message')} name="content">
          <TextArea />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button type="primary" htmlType="submit">
            Envoyer
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

HelpModal.propTypes = {
  setContact: PropTypes.func.isRequired,
  handleCloseModalHelp: PropTypes.func.isRequired
};

export default HelpModal;
